import {z} from 'zod';

export const couponCodeSchema = z
  .string()
  .regex(/^[A-Z0-9-]+$/, 'ID must be alphanumeric, uppercase and dash separated');
